import { createAsyncThunk } from "@reduxjs/toolkit";
import { alertsApiService } from "../services/api";
import { Alert, AlertStatistics, AlertFilters } from "../interfaces/alerts";

export const fetchAlerts = createAsyncThunk(
  "alerts/fetchAlerts",
  async (
    {
      companyId,
      filters,
      limit,
      offset,
    }: {
      companyId: string;
      filters?: AlertFilters;
      limit?: number;
      offset?: number;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await alertsApiService.getAlerts(companyId, {
        severity: filters?.severity,
        limit: limit || 100,
        offset: offset || 0,
      });
      return response;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Error fetching alerts"
      );
    }
  }
);

export const fetchAlertStatistics = createAsyncThunk(
  "alerts/fetchAlertStatistics",
  async (companyId: string, { rejectWithValue }) => {
    try {
      const response = await alertsApiService.getStatistics(companyId);
      return response;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Error fetching alert statistics"
      );
    }
  }
);

export const resolveAlert = createAsyncThunk(
  "alerts/resolveAlert",
  async (
    { companyId, alertId }: { companyId: string; alertId: number },
    { rejectWithValue }
  ) => {
    try {
      await alertsApiService.resolveAlert(companyId, alertId);
      return alertId;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Error resolving alert"
      );
    }
  }
);
